import _ from 'underscore';
import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import NextLink from 'components/NextLink';

import styles from './styles.module.scss';

const Tag = ({ title, url, target, onClick, active, theme, next }) => {
	const tagCx = cx(styles.Tag, styles[`Tag_theme_${theme}`], {
		[styles.Tag_active]: active
	});

	return !url ? (
		<button type="button" className={tagCx} onClick={onClick} data-cy="tag">
			{title}
		</button>
	) : (
		<NextLink href={url} className={tagCx} target={target} next={next}>
			{title}
		</NextLink>
	);
};

Tag.propTypes = {
	title: PropTypes.string.isRequired,
	url: PropTypes.string,
	target: PropTypes.oneOf(['_blank']),
	active: PropTypes.bool,
	theme: PropTypes.oneOf(['contrast', 'gray', 'more']),
	onClick: PropTypes.func,
	next: PropTypes.bool
};

Tag.defaultProps = {
	active: false,
	onClick: _.noop,
	next: false
};

export default Tag;
